import { gql, useMutation } from "@apollo/client";

const createIntervention = gql`
  mutation CreateIntervention(
    $name: String!
    $description: String
    $visibility: InterventionVisibility
  ) {
    createIntervention(name: $name, description: $description, visibility: $visibility) {
      id
    }
  }
`;

export const useCreateIntervention = () => {
  return useMutation<
    { createIntervention: { id: string } },
    { name: string; description: string; visibility: string }
  >(createIntervention, { refetchQueries: ["intervention"] });
};

const duplicateIntervention = gql`
  mutation CloneIntervention($cloneInterventionId: ID!, $newName: String) {
    cloneIntervention(id: $cloneInterventionId, newName: $newName) {
      id
    }
  }
`;

export const useDuplicateIntervention = () => {
  return useMutation<
    { cloneIntervention: { id: string } },
    { cloneInterventionId: string; newName?: string }
  >(duplicateIntervention, { refetchQueries: ["intervention"] });
};

const createInterventionDraftVersion = gql`
  mutation CreateInterventionDraftVersion($id: ID!) {
    createInterventionDraftVersion(id: $id) {
      id
    }
  }
`;

export const useCreateInterventionDraftVersion = () => {
  return useMutation<{ createInterventionDraftVersion: { id: string } }, { id: string }>(
    createInterventionDraftVersion,
    { refetchQueries: ["intervention", "interventions"] },
  );
};

const archiveIntervention = gql`
  mutation ArchiveIntervention($archiveInterventionId: ID!) {
    archiveIntervention(id: $archiveInterventionId) {
      id
    }
  }
`;

export const useArchiveIntervention = () => {
  return useMutation<{ archiveIntervention: { id: string } }, { archiveInterventionId: string }>(
    archiveIntervention,
    { refetchQueries: ["intervention"] },
  );
};

const restoreIntervention = gql`
  mutation RestoreIntervention($interventionId: ID!) {
    restoreIntervention(id: $interventionId) {
      id
    }
  }
`;

export const useRestoreIntervention = () => {
  return useMutation<{ restoreIntervention: { id: string } }, { interventionId: string }>(
    restoreIntervention,
    { refetchQueries: ["intervention"] },
  );
};
